import { NumberHelper } from 'core/helpers';

export const formatQuantity = (quantity: number | string): number => {
  return NumberHelper.round(Number(quantity), NumberHelper.DEFAULT_DECIMALS);
};
